import { FunctionalComponent, h, VNode } from 'preact';
import Button from '@components/atoms/button/button';
import { FeedbackState } from '@state/feedbackState';
import {
  FeedbackFormContainer,
  FeedbackFormLogo,
  FeedbackFormSubheading,
} from './feedback-form.styles';
import InputField from '@components/atoms/input/input-field';
import { useScreen } from '@hooks/useScreen';
import Icon from '@components/atoms/icon/icon';
import { handleNext as next } from './feedback-form';
import { resetRatingSelection } from './ratings';
import RatingbarState from '@state/ratingbarState';

const FeedbackFormContact: FunctionalComponent<{ handleSubmit: () => void }> = ({
  handleSubmit,
}): VNode => {
  const { isTablet } = useScreen();
  const { feedback, isEmailValid, resetFeedbackState } = FeedbackState.value;
  const { resetRatingbarState } = RatingbarState.value;

  const handleNext = () => {
    handleSubmit();
    resetFeedbackState();
    resetRatingSelection();
    resetRatingbarState();
    next();
  };

  const handleEmailInput = (event) => {
    feedback.value.email.value = event.target.value;
  };

  const handleConfirmEmail = () => {
    if (isEmailValid.value) {
      handleNext();
    }
  };

  return (
    <FeedbackFormContainer className="feedback-form" $isMobile={isTablet}>
      <FeedbackFormLogo className="feedback-form-logo">
        <Icon name="tick" brandFill />
      </FeedbackFormLogo>
      <FeedbackFormSubheading className="feedback-form-heading" style={{}}>
        We may wish to follow up. Please enter your email below if you are happy for us to contact
        you.
      </FeedbackFormSubheading>
      <InputField
        value={feedback.value.email.value}
        className="feedback-form-input-email"
        onChange={handleEmailInput}
        placeholder="Email"
        error={!isEmailValid.value}
      />
      <Button type={'gradient'} onClick={handleConfirmEmail} disabled={!isEmailValid.value}>
        Confirm Email
      </Button>
      <a
        onClick={() => handleNext()}
        style={{
          color: '#555555',
          opacity: '0.7',
          textAlign: 'center',
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
      >
        Skip
      </a>
    </FeedbackFormContainer>
  );
};

export default FeedbackFormContact;
